export default ( image, collection = 'default', size = null ) => {
  if ( !image ) return ''

  if ( !size) return image.url

  const fullNameSplitted = image.file_name.split(/\.(jpe?g|gif|png)$/i)
  if ( !fullNameSplitted ) return image.url

  let fileName = fullNameSplitted[0]
  let hasConversion = false

  if ( image.custom_properties && image.custom_properties.generated_conversions && image.custom_properties.generated_conversions[size] ) {
    fileName += `-${size}`
    hasConversion = true
  }

  if ( !hasConversion || image.collection_name !== collection ) {
    return image.url
  }

  const matches = image.url.match( /^(.*?)\/images\//, image.url )

  if ( !matches ) {
    return image.url;
  }

  const base = matches[0]

  return `${base}${image.id}/conversions/${fileName}.jpg`
}

export const getImages = ( images, collection = 'default' ) => {
  if ( !images || !images.length) return

  const filteredImages = images.filter(image => image.collection_name === collection).sort((a, b) => a.order_column - b.order_column)
  return filteredImages
}

export const getFeaturedImage = ( images, collection = 'default') => {
  if ( !images || !images.length) return

  const filteredImages = images.filter(image => image.collection_name === collection)
  if ( filteredImages.length > 0 ) {
    return filteredImages[0]
  }
  return ''
}
